export const formats = {
  STICKY_DATE: "eeee, LLLL d",
  STICKY_START: "h:mm a",
  START: "eee, LLL d, h:mm a",
  END: "h:mm a zzz",
}
